module.exports = __webpack_public_path__ + "img/p-2-3.61512569.jpg";